module.exports = __webpack_public_path__ + "static/media/item4.8eaf95dc.png";